/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { TokenName, LoggedUser, UserAvatar, RefreshTokenName } from '../config/constants';
import { LocalStorageService } from './storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private token = TokenName;
  private LoggedUser = LoggedUser;
  private UserAvatar = UserAvatar;
  expiredDate: any;

  constructor(
    private localStorageService: LocalStorageService
  ) { }

  clear() {
    this.localStorageService.removeData(this.token);
  }
  setFogetExpiryLink() {
    this.expiredDate = new Date();
    this.expiredDate.setTime(this.expiredDate.getTime() + (15) * 60000);
  }
  setReviewFogetExpiryLink(path: any) {
    this.expiredDate = new Date();
    this.expiredDate.setTime(this.expiredDate.getTime() + (15) * 60000);
  }

  exists() {
    const value = this.get()
    return value != null && value != '';
  }

  clearAll() {
    this.localStorageService.clearData();
  }

  get(): string {
    return this.localStorageService.getData(this.token) as string;
  }
  getRefreshToken(): string {
    return this.localStorageService.getData("RefreshToken") as string;
  }

  set(token: string, refreshToken: string, rememberMe: boolean) {
    this.localStorageService.saveData(this.token, token);
    this.localStorageService.saveData(RefreshTokenName, refreshToken);
  }


  setRefreshHelper() {
    const date = new Date();
    date.setTime(date.getTime() + (460 * 60 * 1000));
  }
  setExpiry() {
    this.localStorageService.removeData(this.UserAvatar);
    this.localStorageService.removeData(this.token);
    this.localStorageService.removeData(this.LoggedUser);
    this.localStorageService.removeData(RefreshTokenName);
  }

  SetLoggedInDetail(data: any) {
    this.localStorageService.saveData(this.LoggedUser, JSON.stringify(data))
  }

  SetUserAvatar(data: any) {
    this.localStorageService.saveData(this.UserAvatar, JSON.stringify(data));
  }

  GetUserAvatar(): string {
    return this.localStorageService.getData(this.UserAvatar) as string;
  }
  saveUserAvatar(data: string) {
    this.localStorageService.saveData('CG_UserAvatar', JSON.stringify(data));
  }
  clearLoggedInDetail() {
    this.localStorageService.removeData(this.LoggedUser);
    this.localStorageService.removeData(this.UserAvatar);
  }
  getLoggedInDetail(): string {
    return this.localStorageService.getData(this.LoggedUser) as string;
  }
  getLoggedInExists() {
    const value = this.getLoggedInDetail()
    return !!value;
  }
}
